import { Paginator } from "primereact/paginator";

interface PaginationProps {
  totalRecords: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (page: number, rowsPerPage: number) => void;
  rowsPerPageOptions?: number[];
}

export default function Pagination({
  totalRecords,
  page,
  rowsPerPage,
  onPageChange,
  rowsPerPageOptions = [10, 20, 50],
}: PaginationProps) {
  const handlePageChange = (event: any) => {
    onPageChange(event.page, event.rows);
  };

  return (
    <div className="flex justify-content-end mt-3">
      <Paginator
        first={page * rowsPerPage}
        rows={rowsPerPage}
        totalRecords={totalRecords}
        rowsPerPageOptions={rowsPerPageOptions}
        onPageChange={handlePageChange}
        template="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        className="p-paginator-sm"
      />
    </div>
  );
}
